/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UploadConfig model module.
 * @module model/UploadConfig
 * @version 1.0.0
 */
class UploadConfig {
    /**
     * Constructs a new <code>UploadConfig</code>.
     * @alias module:model/UploadConfig
     * @param requiredFieldIds {Array.<String>} ids of fields of that set that must be filled before an upload starts
     */
    constructor(requiredFieldIds) { 
        
        UploadConfig.initialize(this, requiredFieldIds);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, requiredFieldIds) { 
        obj['requiredFieldIds'] = requiredFieldIds;
    }

    /**
     * Constructs a <code>UploadConfig</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UploadConfig} obj Optional instance to populate.
     * @return {module:model/UploadConfig} The populated <code>UploadConfig</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UploadConfig();

            if (data.hasOwnProperty('metadataSetId')) {
                obj['metadataSetId'] = ApiClient.convertToType(data['metadataSetId'], 'String');
            }
            if (data.hasOwnProperty('requiredFieldIds')) {
                obj['requiredFieldIds'] = ApiClient.convertToType(data['requiredFieldIds'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UploadConfig</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UploadConfig</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UploadConfig.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['metadataSetId'] && !(typeof data['metadataSetId'] === 'string' || data['metadataSetId'] instanceof String)) {
            throw new Error("Expected the field `metadataSetId` to be a primitive type in the JSON string but got " + data['metadataSetId']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['requiredFieldIds'])) {
            throw new Error("Expected the field `requiredFieldIds` to be an array in the JSON data but got " + data['requiredFieldIds']);
        }

        return true;
    }


}

UploadConfig.RequiredProperties = ["requiredFieldIds"];

/**
 * set whose fields the upload dialog shows; null = no metadata
 * @member {String} metadataSetId
 */
UploadConfig.prototype['metadataSetId'] = undefined;

/**
 * ids of fields of that set that must be filled before an upload starts
 * @member {Array.<String>} requiredFieldIds
 */
UploadConfig.prototype['requiredFieldIds'] = undefined;






export default UploadConfig;

